/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { ReceiveMessageHandler } from '@mep/web-browser-bridge';
import { Store } from '@ngrx/store';
import { ApplyIdReceiveController } from '../../receive-controllers/apply-id-receive-controller';
import { ApplyIdClick, ChangeHeight, ClosePopupAction, ValidateSelection } from './apply-id-actions';
import { selectValidSelection } from './apply-id-selector';
import { IApplyIdFacade } from '../../../../../data-access/src/lib/domain/facades-models/apply-id-facade-interface';
import { Observable } from 'rxjs';
import { ApplyIdState } from './apply-id-reducer';
import { LocalStorageService } from '../../../../../utils/src/lib/local-storage/local-storage.service';
import { GlobalConstants } from '../../constants/global-constants';

@Injectable({
  providedIn: 'root',
})
export class ApplyIdFacade implements IApplyIdFacade {
  constructor(
    private store: Store<ApplyIdState>,
    private readonly receiveMessageHandler: ReceiveMessageHandler,
    private localStorage: LocalStorageService
  ) {
    this.receiveMessageHandler.registerController(new ApplyIdReceiveController(localStorage));
  }

  public windowResize(height: number) {
    this.store.dispatch(ChangeHeight({ height: height}));
  }

  public validateApplySelection(): Observable<any> {
    this.store.dispatch(ValidateSelection());
    return this.store.select(selectValidSelection);
  }

  public applyIdClick(id: string) {
    localStorage.setItem(GlobalConstants.ApplyIdResponseKey, '');
    this.store.dispatch(ApplyIdClick({ id: id }));
  }

  public closePopupAction(): void {
    this.store.dispatch(ClosePopupAction());
  }
}
